export const DatabaseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="25"
    height="25"
    fill="none"
    stroke="black"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round">
    <ellipse cx="32" cy="12" rx="20" ry="8" />
    <path d="M12 12v16c0 4 8.95 8 20 8s20-4 20-8V12" />
    <path d="M12 28v16c0 4 8.95 8 20 8s20-4 20-8V28" />
  </svg>
);
